import styled from 'styled-components';
import { ProfileImage } from 'components';
import { palette, theme } from 'styled-tools';

export const ProfileContainer = styled.div`
    display:flex;
    flex-direction: column;
    align-items: center;
`;

interface ImageWrapperProps {
    background?: string;
}

export const ImageWrapper = styled.div`
    width: 104px;
    height: 104px;
`;

export const LabelWrapper = styled.div`
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const LabelWIthSubName = styled.div`
    display: flex;
    margin-left: 4px;
    line-height: 22px;    
`;

export const SubName = styled.span`
    margin-left: 4px;    
    color: ${palette('gray_opacity_600')};
    ${theme('fontStyle.subtitle')};
`;

export const FromProfileImage = styled(ProfileImage)`
    cursor: pointer;
`;